var map = {
	"./absurdism/0000S.png": 12863,
	"./absurdism/0001S.png": 78708,
	"./absurdism/0002S.png": 75491,
	"./absurdism/0003S.png": 29818,
	"./absurdism/0004S.png": 55446,
	"./absurdism/0005S.png": 76471,
	"./absurdism/0006S.png": 56870,
	"./absurdism/0007S.png": 65449,
	"./absurdism/0008S.png": 79805,
	"./absurdism/0009S.png": 67299,
	"./absurdism/0010S.png": 25160,
	"./absurdism/0011S.png": 76535,
	"./absurdism/0119S.png": 2422,
	"./absurdism/0120S.png": 53330,
	"./absurdism/0121S.png": 48600,
	"./absurdism/0122S.png": 93363,
	"./absurdism/0123S.png": 99593,
	"./absurdism/0124S.png": 652,
	"./absurdism/0125S.png": 20509,
	"./absurdism/0126S.png": 81117,
	"./absurdism/0127S.png": 15629,
	"./absurdism/0128S.png": 99785,
	"./absurdism/0129S.png": 54711,
	"./absurdism/0130S.png": 77800,
	"./absurdism/0238S.png": 9769,
	"./absurdism/0239S.png": 49365,
	"./absurdism/0240S.png": 79484,
	"./absurdism/0241S.png": 53146,
	"./absurdism/0242S.png": 52427,
	"./absurdism/0243S.png": 35693,
	"./absurdism/0244S.png": 10941,
	"./absurdism/0245S.png": 72600,
	"./absurdism/0246S.png": 98914,
	"./absurdism/0247S.png": 59917,
	"./absurdism/0248S.png": 78269,
	"./absurdism/0249S.png": 78612,
	"./absurdism/0357S.png": 93573,
	"./absurdism/0358S.png": 6289,
	"./absurdism/0359S.png": 84445,
	"./absurdism/0360S.png": 88048,
	"./absurdism/0361S.png": 99450,
	"./absurdism/0362S.png": 52011,
	"./absurdism/0363S.png": 55022,
	"./absurdism/0364S.png": 42193,
	"./absurdism/0365S.png": 80746,
	"./absurdism/0366S.png": 1435,
	"./absurdism/0367S.png": 48452,
	"./absurdism/0368S.png": 5385,
	"./absurdism/0476S.png": 86723,
	"./absurdism/0477S.png": 45990,
	"./absurdism/0478S.png": 98321,
	"./absurdism/0479S.png": 24330,
	"./absurdism/0480S.png": 93134,
	"./absurdism/0481S.png": 12745,
	"./absurdism/0482S.png": 93534,
	"./absurdism/0483S.png": 87042,
	"./absurdism/0484S.png": 64044,
	"./absurdism/0485S.png": 42706,
	"./absurdism/0486S.png": 65876,
	"./absurdism/0487S.png": 12741,
	"./absurdism/0595S.png": 50783,
	"./absurdism/0596S.png": 74023,
	"./absurdism/0597S.png": 8941,
	"./absurdism/0598S.png": 7849,
	"./absurdism/0599S.png": 29262,
	"./absurdism/0600S.png": 45786,
	"./absurdism/0601S.png": 14439,
	"./absurdism/0602S.png": 77399,
	"./absurdism/0603S.png": 13353,
	"./absurdism/0604S.png": 95803,
	"./absurdism/0605S.png": 29897,
	"./absurdism/0606S.png": 28387,
	"./absurdism/0714S.png": 82782,
	"./absurdism/0715S.png": 51744,
	"./absurdism/0716S.png": 19889,
	"./absurdism/0717S.png": 65677,
	"./absurdism/0718S.png": 71315,
	"./absurdism/0719S.png": 99197,
	"./absurdism/0720S.png": 71028,
	"./absurdism/0721S.png": 3046,
	"./absurdism/0722S.png": 53163,
	"./absurdism/0723S.png": 83723,
	"./absurdism/0724S.png": 18259,
	"./absurdism/0725S.png": 79440,
	"./absurdism/0833S.png": 61137,
	"./absurdism/0834S.png": 38437,
	"./absurdism/0835S.png": 65049,
	"./absurdism/0836S.png": 61902,
	"./absurdism/0837S.png": 45959,
	"./absurdism/0838S.png": 67435,
	"./absurdism/0839S.png": 6898,
	"./absurdism/0840S.png": 39500,
	"./absurdism/0841S.png": 98026,
	"./absurdism/0842S.png": 78238,
	"./absurdism/0843S.png": 15977,
	"./absurdism/0844S.png": 89670,
	"./absurdism/0952S.png": 36781,
	"./absurdism/0953S.png": 13896,
	"./absurdism/0954S.png": 37055,
	"./absurdism/0955S.png": 85439,
	"./absurdism/0956S.png": 29816,
	"./absurdism/0957S.png": 93077,
	"./absurdism/0958S.png": 68332,
	"./absurdism/0959S.png": 94162,
	"./absurdism/0960S.png": 15189,
	"./absurdism/0961S.png": 79969,
	"./absurdism/0962S.png": 52410,
	"./absurdism/0963S.png": 96149,
	"./absurdism/1071S.png": 7592,
	"./absurdism/1072S.png": 59183,
	"./absurdism/1073S.png": 60673,
	"./absurdism/1074S.png": 95181,
	"./absurdism/1075S.png": 9422,
	"./absurdism/1076S.png": 30941,
	"./absurdism/1077S.png": 98419,
	"./absurdism/1078S.png": 35018,
	"./absurdism/1079S.png": 74501,
	"./absurdism/1080S.png": 33569,
	"./absurdism/1081S.png": 81810,
	"./absurdism/1082S.png": 72809,
	"./absurdism/1190S.png": 47385,
	"./absurdism/1191S.png": 52204,
	"./absurdism/1192S.png": 67328,
	"./absurdism/1193S.png": 32389,
	"./absurdism/1194S.png": 74997,
	"./absurdism/1195S.png": 33693,
	"./absurdism/1196S.png": 33005,
	"./absurdism/1197S.png": 67890,
	"./absurdism/1198S.png": 37627,
	"./absurdism/1199S.png": 23737,
	"./absurdism/1200S.png": 15241,
	"./absurdism/1201S.png": 77563,
	"./absurdism/1309S.png": 76002,
	"./absurdism/1310S.png": 12178,
	"./absurdism/1311S.png": 65021,
	"./absurdism/1312S.png": 96783,
	"./absurdism/1313S.png": 83442,
	"./absurdism/1314S.png": 30714,
	"./absurdism/1315S.png": 91867,
	"./absurdism/1316S.png": 20304,
	"./absurdism/1317S.png": 17564,
	"./absurdism/1318S.png": 29136,
	"./absurdism/1319S.png": 51270,
	"./absurdism/1320S.png": 83228,
	"./altruism/0012S.png": 65784,
	"./altruism/0013S.png": 40782,
	"./altruism/0014S.png": 79268,
	"./altruism/0015S.png": 89789,
	"./altruism/0016S.png": 96242,
	"./altruism/0017S.png": 42328,
	"./altruism/0018S.png": 33979,
	"./altruism/0019S.png": 10035,
	"./altruism/0020S.png": 42297,
	"./altruism/0021S.png": 76123,
	"./altruism/0022S.png": 65651,
	"./altruism/0023S.png": 32227,
	"./altruism/0024S.png": 84313,
	"./altruism/0131S.png": 85401,
	"./altruism/0132S.png": 74564,
	"./altruism/0133S.png": 48151,
	"./altruism/0134S.png": 90640,
	"./altruism/0135S.png": 82837,
	"./altruism/0136S.png": 98429,
	"./altruism/0137S.png": 59811,
	"./altruism/0138S.png": 87390,
	"./altruism/0139S.png": 88189,
	"./altruism/0140S.png": 32873,
	"./altruism/0141S.png": 59870,
	"./altruism/0142S.png": 50028,
	"./altruism/0143S.png": 8364,
	"./altruism/0250S.png": 85419,
	"./altruism/0251S.png": 6987,
	"./altruism/0252S.png": 20619,
	"./altruism/0253S.png": 18002,
	"./altruism/0254S.png": 30115,
	"./altruism/0255S.png": 75327,
	"./altruism/0256S.png": 11511,
	"./altruism/0257S.png": 1208,
	"./altruism/0258S.png": 72536,
	"./altruism/0259S.png": 77977,
	"./altruism/0260S.png": 18586,
	"./altruism/0261S.png": 56560,
	"./altruism/0262S.png": 77572,
	"./altruism/0369S.png": 10606,
	"./altruism/0370S.png": 89974,
	"./altruism/0371S.png": 7227,
	"./altruism/0372S.png": 24138,
	"./altruism/0373S.png": 8901,
	"./altruism/0374S.png": 35021,
	"./altruism/0375S.png": 5779,
	"./altruism/0376S.png": 86688,
	"./altruism/0377S.png": 19444,
	"./altruism/0378S.png": 22344,
	"./altruism/0379S.png": 83343,
	"./altruism/0380S.png": 55130,
	"./altruism/0381S.png": 96971,
	"./altruism/0488S.png": 8738,
	"./altruism/0489S.png": 47226,
	"./altruism/0490S.png": 25440,
	"./altruism/0491S.png": 85926,
	"./altruism/0492S.png": 91408,
	"./altruism/0493S.png": 18158,
	"./altruism/0494S.png": 74224,
	"./altruism/0495S.png": 57065,
	"./altruism/0496S.png": 22688,
	"./altruism/0497S.png": 64573,
	"./altruism/0498S.png": 67606,
	"./altruism/0499S.png": 6037,
	"./altruism/0500S.png": 51890,
	"./altruism/0607S.png": 7249,
	"./altruism/0608S.png": 13389,
	"./altruism/0609S.png": 59847,
	"./altruism/0610S.png": 92858,
	"./altruism/0611S.png": 72788,
	"./altruism/0612S.png": 65055,
	"./altruism/0613S.png": 89272,
	"./altruism/0614S.png": 55179,
	"./altruism/0615S.png": 73218,
	"./altruism/0616S.png": 42446,
	"./altruism/0617S.png": 91618,
	"./altruism/0618S.png": 86822,
	"./altruism/0619S.png": 94918,
	"./altruism/0726S.png": 71599,
	"./altruism/0727S.png": 52719,
	"./altruism/0728S.png": 37245,
	"./altruism/0729S.png": 54036,
	"./altruism/0730S.png": 23069,
	"./altruism/0731S.png": 65207,
	"./altruism/0732S.png": 16076,
	"./altruism/0733S.png": 16121,
	"./altruism/0734S.png": 44429,
	"./altruism/0735S.png": 48395,
	"./altruism/0736S.png": 43954,
	"./altruism/0737S.png": 58717,
	"./altruism/0738S.png": 16722,
	"./altruism/0845S.png": 6759,
	"./altruism/0846S.png": 85192,
	"./altruism/0847S.png": 27455,
	"./altruism/0848S.png": 44172,
	"./altruism/0849S.png": 30353,
	"./altruism/0850S.png": 52014,
	"./altruism/0851S.png": 83741,
	"./altruism/0852S.png": 50074,
	"./altruism/0853S.png": 78355,
	"./altruism/0854S.png": 65906,
	"./altruism/0855S.png": 8111,
	"./altruism/0856S.png": 78480,
	"./altruism/0857S.png": 92939,
	"./altruism/0964S.png": 33551,
	"./altruism/0965S.png": 76106,
	"./altruism/0966S.png": 26411,
	"./altruism/0967S.png": 27734,
	"./altruism/0968S.png": 79502,
	"./altruism/0969S.png": 49007,
	"./altruism/0970S.png": 212,
	"./altruism/0971S.png": 46116,
	"./altruism/0972S.png": 38447,
	"./altruism/0973S.png": 19534,
	"./altruism/0974S.png": 80401,
	"./altruism/0975S.png": 84536,
	"./altruism/0976S.png": 11622,
	"./altruism/1083S.png": 833,
	"./altruism/1084S.png": 62926,
	"./altruism/1085S.png": 65043,
	"./altruism/1086S.png": 68103,
	"./altruism/1087S.png": 36778,
	"./altruism/1088S.png": 32162,
	"./altruism/1089S.png": 92903,
	"./altruism/1090S.png": 45782,
	"./altruism/1091S.png": 94708,
	"./altruism/1092S.png": 5324,
	"./altruism/1093S.png": 47398,
	"./altruism/1094S.png": 64772,
	"./altruism/1095S.png": 37766,
	"./altruism/1202S.png": 90168,
	"./altruism/1203S.png": 61788,
	"./altruism/1204S.png": 51863,
	"./altruism/1205S.png": 55975,
	"./altruism/1206S.png": 59310,
	"./altruism/1207S.png": 63440,
	"./altruism/1208S.png": 35208,
	"./altruism/1209S.png": 11842,
	"./altruism/1210S.png": 8919,
	"./altruism/1211S.png": 91906,
	"./altruism/1212S.png": 62181,
	"./altruism/1213S.png": 40809,
	"./altruism/1214S.png": 19588,
	"./altruism/1321S.png": 2654,
	"./altruism/1322S.png": 79693,
	"./altruism/1323S.png": 53233,
	"./altruism/1324S.png": 29065,
	"./altruism/1325S.png": 41920,
	"./altruism/1326S.png": 72305,
	"./altruism/1327S.png": 11428,
	"./altruism/1328S.png": 2839,
	"./altruism/1329S.png": 54968,
	"./altruism/1330S.png": 49700,
	"./altruism/1331S.png": 37264,
	"./altruism/1332S.png": 14510,
	"./altruism/1333S.png": 93085,
	"./cynicism/0025S.png": 64956,
	"./cynicism/0026S.png": 76017,
	"./cynicism/0027S.png": 66190,
	"./cynicism/0028S.png": 41402,
	"./cynicism/0029S.png": 53560,
	"./cynicism/0030S.png": 95811,
	"./cynicism/0031S.png": 36044,
	"./cynicism/0032S.png": 27187,
	"./cynicism/0033S.png": 70177,
	"./cynicism/0034S.png": 21551,
	"./cynicism/0035S.png": 62888,
	"./cynicism/0144S.png": 11320,
	"./cynicism/0145S.png": 87905,
	"./cynicism/0146S.png": 74970,
	"./cynicism/0147S.png": 49529,
	"./cynicism/0148S.png": 17134,
	"./cynicism/0149S.png": 84482,
	"./cynicism/0150S.png": 99366,
	"./cynicism/0151S.png": 51209,
	"./cynicism/0152S.png": 62672,
	"./cynicism/0153S.png": 35371,
	"./cynicism/0154S.png": 1906,
	"./cynicism/0263S.png": 66425,
	"./cynicism/0264S.png": 48927,
	"./cynicism/0265S.png": 88642,
	"./cynicism/0266S.png": 58367,
	"./cynicism/0267S.png": 52200,
	"./cynicism/0268S.png": 80906,
	"./cynicism/0269S.png": 76042,
	"./cynicism/0270S.png": 95978,
	"./cynicism/0271S.png": 71534,
	"./cynicism/0272S.png": 88058,
	"./cynicism/0273S.png": 70575,
	"./cynicism/0382S.png": 41612,
	"./cynicism/0383S.png": 49084,
	"./cynicism/0384S.png": 61402,
	"./cynicism/0385S.png": 85198,
	"./cynicism/0386S.png": 47595,
	"./cynicism/0387S.png": 42106,
	"./cynicism/0388S.png": 6664,
	"./cynicism/0389S.png": 71965,
	"./cynicism/0390S.png": 51277,
	"./cynicism/0391S.png": 90312,
	"./cynicism/0392S.png": 82984,
	"./cynicism/0501S.png": 22666,
	"./cynicism/0502S.png": 30605,
	"./cynicism/0503S.png": 26271,
	"./cynicism/0504S.png": 48192,
	"./cynicism/0505S.png": 48585,
	"./cynicism/0506S.png": 66160,
	"./cynicism/0507S.png": 43566,
	"./cynicism/0508S.png": 28485,
	"./cynicism/0509S.png": 160,
	"./cynicism/0510S.png": 3335,
	"./cynicism/0511S.png": 70828,
	"./cynicism/0620S.png": 4186,
	"./cynicism/0621S.png": 72517,
	"./cynicism/0622S.png": 34103,
	"./cynicism/0623S.png": 51394,
	"./cynicism/0624S.png": 27252,
	"./cynicism/0625S.png": 58282,
	"./cynicism/0626S.png": 50813,
	"./cynicism/0627S.png": 21795,
	"./cynicism/0628S.png": 1988,
	"./cynicism/0629S.png": 66966,
	"./cynicism/0630S.png": 70615,
	"./cynicism/0739S.png": 67658,
	"./cynicism/0740S.png": 85833,
	"./cynicism/0741S.png": 31224,
	"./cynicism/0742S.png": 17347,
	"./cynicism/0743S.png": 73022,
	"./cynicism/0744S.png": 84924,
	"./cynicism/0745S.png": 34969,
	"./cynicism/0746S.png": 16855,
	"./cynicism/0747S.png": 88367,
	"./cynicism/0748S.png": 62240,
	"./cynicism/0749S.png": 68572,
	"./cynicism/0858S.png": 6890,
	"./cynicism/0859S.png": 25826,
	"./cynicism/0860S.png": 27779,
	"./cynicism/0861S.png": 67247,
	"./cynicism/0862S.png": 37566,
	"./cynicism/0863S.png": 87851,
	"./cynicism/0864S.png": 76687,
	"./cynicism/0865S.png": 52717,
	"./cynicism/0866S.png": 35635,
	"./cynicism/0867S.png": 54070,
	"./cynicism/0868S.png": 98180,
	"./cynicism/0977S.png": 72697,
	"./cynicism/0978S.png": 90008,
	"./cynicism/0979S.png": 93578,
	"./cynicism/0980S.png": 8915,
	"./cynicism/0981S.png": 80008,
	"./cynicism/0982S.png": 68900,
	"./cynicism/0983S.png": 4242,
	"./cynicism/0984S.png": 48155,
	"./cynicism/0985S.png": 14805,
	"./cynicism/0986S.png": 67889,
	"./cynicism/0987S.png": 66611,
	"./cynicism/1096S.png": 23645,
	"./cynicism/1097S.png": 67778,
	"./cynicism/1098S.png": 20719,
	"./cynicism/1099S.png": 76184,
	"./cynicism/1100S.png": 93150,
	"./cynicism/1101S.png": 63480,
	"./cynicism/1102S.png": 25554,
	"./cynicism/1103S.png": 41764,
	"./cynicism/1104S.png": 42610,
	"./cynicism/1105S.png": 93784,
	"./cynicism/1106S.png": 94976,
	"./cynicism/1215S.png": 84624,
	"./cynicism/1216S.png": 55161,
	"./cynicism/1217S.png": 53986,
	"./cynicism/1218S.png": 49089,
	"./cynicism/1219S.png": 43287,
	"./cynicism/1220S.png": 40739,
	"./cynicism/1221S.png": 61753,
	"./cynicism/1222S.png": 84529,
	"./cynicism/1223S.png": 67774,
	"./cynicism/1224S.png": 639,
	"./cynicism/1225S.png": 54264,
	"./cynicism/1334S.png": 81,
	"./cynicism/1335S.png": 17893,
	"./cynicism/1336S.png": 21871,
	"./cynicism/1337S.png": 81518,
	"./cynicism/1338S.png": 41504,
	"./cynicism/1339S.png": 30180,
	"./cynicism/1340S.png": 47868,
	"./cynicism/1341S.png": 13793,
	"./cynicism/1342S.png": 82746,
	"./cynicism/1343S.png": 26890,
	"./cynicism/1344S.png": 74087,
	"./existentialism/0036S.png": 76128,
	"./existentialism/0037S.png": 59016,
	"./existentialism/0038S.png": 67263,
	"./existentialism/0039S.png": 83519,
	"./existentialism/0040S.png": 35625,
	"./existentialism/0041S.png": 57533,
	"./existentialism/0042S.png": 81785,
	"./existentialism/0043S.png": 65822,
	"./existentialism/0044S.png": 34922,
	"./existentialism/0045S.png": 4978,
	"./existentialism/0046S.png": 25781,
	"./existentialism/0047S.png": 22656,
	"./existentialism/0048S.png": 39885,
	"./existentialism/0049S.png": 94264,
	"./existentialism/0050S.png": 25435,
	"./existentialism/0155S.png": 94251,
	"./existentialism/0156S.png": 19664,
	"./existentialism/0157S.png": 42807,
	"./existentialism/0158S.png": 61667,
	"./existentialism/0159S.png": 67349,
	"./existentialism/0160S.png": 89361,
	"./existentialism/0161S.png": 72071,
	"./existentialism/0162S.png": 40443,
	"./existentialism/0163S.png": 68086,
	"./existentialism/0164S.png": 82835,
	"./existentialism/0165S.png": 3424,
	"./existentialism/0166S.png": 9013,
	"./existentialism/0167S.png": 40317,
	"./existentialism/0168S.png": 95331,
	"./existentialism/0169S.png": 73337,
	"./existentialism/0274S.png": 88012,
	"./existentialism/0275S.png": 70943,
	"./existentialism/0276S.png": 32862,
	"./existentialism/0277S.png": 70315,
	"./existentialism/0278S.png": 12556,
	"./existentialism/0279S.png": 97068,
	"./existentialism/0280S.png": 74365,
	"./existentialism/0281S.png": 12075,
	"./existentialism/0282S.png": 51132,
	"./existentialism/0283S.png": 52463,
	"./existentialism/0284S.png": 61044,
	"./existentialism/0285S.png": 68558,
	"./existentialism/0286S.png": 59124,
	"./existentialism/0287S.png": 21164,
	"./existentialism/0288S.png": 76420,
	"./existentialism/0393S.png": 80054,
	"./existentialism/0394S.png": 94796,
	"./existentialism/0395S.png": 89029,
	"./existentialism/0396S.png": 71399,
	"./existentialism/0397S.png": 18612,
	"./existentialism/0398S.png": 16090,
	"./existentialism/0399S.png": 27362,
	"./existentialism/0400S.png": 4413,
	"./existentialism/0401S.png": 83362,
	"./existentialism/0402S.png": 44909,
	"./existentialism/0403S.png": 43122,
	"./existentialism/0404S.png": 12018,
	"./existentialism/0405S.png": 29651,
	"./existentialism/0406S.png": 60438,
	"./existentialism/0407S.png": 7372,
	"./existentialism/0512S.png": 98948,
	"./existentialism/0513S.png": 42994,
	"./existentialism/0514S.png": 10610,
	"./existentialism/0515S.png": 68487,
	"./existentialism/0516S.png": 711,
	"./existentialism/0517S.png": 84173,
	"./existentialism/0518S.png": 40088,
	"./existentialism/0519S.png": 59100,
	"./existentialism/0520S.png": 66254,
	"./existentialism/0521S.png": 1227,
	"./existentialism/0522S.png": 23781,
	"./existentialism/0523S.png": 36445,
	"./existentialism/0524S.png": 11474,
	"./existentialism/0525S.png": 3990,
	"./existentialism/0526S.png": 64939,
	"./existentialism/0631S.png": 45545,
	"./existentialism/0632S.png": 36301,
	"./existentialism/0633S.png": 43525,
	"./existentialism/0634S.png": 82813,
	"./existentialism/0635S.png": 6103,
	"./existentialism/0636S.png": 88114,
	"./existentialism/0637S.png": 89955,
	"./existentialism/0638S.png": 74537,
	"./existentialism/0639S.png": 46428,
	"./existentialism/0640S.png": 20942,
	"./existentialism/0641S.png": 62152,
	"./existentialism/0642S.png": 13771,
	"./existentialism/0643S.png": 9098,
	"./existentialism/0644S.png": 30005,
	"./existentialism/0645S.png": 84552,
	"./existentialism/0750S.png": 38494,
	"./existentialism/0751S.png": 30183,
	"./existentialism/0752S.png": 91983,
	"./existentialism/0753S.png": 26807,
	"./existentialism/0754S.png": 91176,
	"./existentialism/0755S.png": 3373,
	"./existentialism/0756S.png": 89259,
	"./existentialism/0757S.png": 77851,
	"./existentialism/0758S.png": 31972,
	"./existentialism/0759S.png": 34453,
	"./existentialism/0760S.png": 97596,
	"./existentialism/0761S.png": 45368,
	"./existentialism/0762S.png": 29041,
	"./existentialism/0763S.png": 82147,
	"./existentialism/0764S.png": 23849,
	"./existentialism/0869S.png": 3743,
	"./existentialism/0870S.png": 57180,
	"./existentialism/0871S.png": 47686,
	"./existentialism/0872S.png": 34741,
	"./existentialism/0873S.png": 72888,
	"./existentialism/0874S.png": 99903,
	"./existentialism/0875S.png": 73000,
	"./existentialism/0876S.png": 85352,
	"./existentialism/0877S.png": 60028,
	"./existentialism/0878S.png": 33754,
	"./existentialism/0879S.png": 64884,
	"./existentialism/0880S.png": 53021,
	"./existentialism/0881S.png": 34276,
	"./existentialism/0882S.png": 90573,
	"./existentialism/0883S.png": 43212,
	"./existentialism/0988S.png": 43823,
	"./existentialism/0989S.png": 35482,
	"./existentialism/0990S.png": 88692,
	"./existentialism/0991S.png": 70985,
	"./existentialism/0992S.png": 84827,
	"./existentialism/0993S.png": 64860,
	"./existentialism/0994S.png": 34382,
	"./existentialism/0995S.png": 14029,
	"./existentialism/0996S.png": 86506,
	"./existentialism/0997S.png": 3752,
	"./existentialism/0998S.png": 12030,
	"./existentialism/0999S.png": 89087,
	"./existentialism/1000S.png": 66875,
	"./existentialism/1001S.png": 30970,
	"./existentialism/1002S.png": 1776,
	"./existentialism/1107S.png": 15922,
	"./existentialism/1108S.png": 33003,
	"./existentialism/1109S.png": 65504,
	"./existentialism/1110S.png": 27716,
	"./existentialism/1111S.png": 33152,
	"./existentialism/1112S.png": 208,
	"./existentialism/1113S.png": 31462,
	"./existentialism/1114S.png": 80859,
	"./existentialism/1115S.png": 29890,
	"./existentialism/1116S.png": 60219,
	"./existentialism/1117S.png": 48639,
	"./existentialism/1118S.png": 96949,
	"./existentialism/1119S.png": 46253,
	"./existentialism/1120S.png": 70617,
	"./existentialism/1121S.png": 1174,
	"./existentialism/1226S.png": 73821,
	"./existentialism/1227S.png": 12362,
	"./existentialism/1228S.png": 67457,
	"./existentialism/1229S.png": 36936,
	"./existentialism/1230S.png": 45930,
	"./existentialism/1231S.png": 66263,
	"./existentialism/1232S.png": 30524,
	"./existentialism/1233S.png": 50115,
	"./existentialism/1234S.png": 81220,
	"./existentialism/1235S.png": 65605,
	"./existentialism/1236S.png": 87255,
	"./existentialism/1237S.png": 48971,
	"./existentialism/1238S.png": 18930,
	"./existentialism/1239S.png": 87298,
	"./existentialism/1240S.png": 68328,
	"./existentialism/1345S.png": 81181,
	"./existentialism/1346S.png": 51090,
	"./existentialism/1347S.png": 23786,
	"./existentialism/1348S.png": 19036,
	"./existentialism/1349S.png": 62256,
	"./existentialism/1350S.png": 98617,
	"./existentialism/1351S.png": 11773,
	"./existentialism/1352S.png": 42233,
	"./existentialism/1353S.png": 4085,
	"./existentialism/1354S.png": 6271,
	"./existentialism/1355S.png": 72013,
	"./existentialism/1356S.png": 33031,
	"./existentialism/1357S.png": 87964,
	"./existentialism/1358S.png": 83559,
	"./existentialism/1359S.png": 63662,
	"./minimalism/0051S.png": 51029,
	"./minimalism/0052S.png": 78798,
	"./minimalism/0053S.png": 5053,
	"./minimalism/0054S.png": 88325,
	"./minimalism/0055S.png": 24632,
	"./minimalism/0056S.png": 69665,
	"./minimalism/0057S.png": 69282,
	"./minimalism/0058S.png": 85074,
	"./minimalism/0059S.png": 51578,
	"./minimalism/0060S.png": 94507,
	"./minimalism/0061S.png": 42750,
	"./minimalism/0062S.png": 48049,
	"./minimalism/0063S.png": 70678,
	"./minimalism/0064S.png": 91152,
	"./minimalism/0170S.png": 99127,
	"./minimalism/0171S.png": 99457,
	"./minimalism/0172S.png": 79251,
	"./minimalism/0173S.png": 22527,
	"./minimalism/0174S.png": 82822,
	"./minimalism/0175S.png": 61605,
	"./minimalism/0176S.png": 12425,
	"./minimalism/0177S.png": 39278,
	"./minimalism/0178S.png": 48959,
	"./minimalism/0179S.png": 22114,
	"./minimalism/0180S.png": 76594,
	"./minimalism/0181S.png": 8469,
	"./minimalism/0182S.png": 85172,
	"./minimalism/0183S.png": 92785,
	"./minimalism/0289S.png": 73049,
	"./minimalism/0290S.png": 67980,
	"./minimalism/0291S.png": 67492,
	"./minimalism/0292S.png": 60740,
	"./minimalism/0293S.png": 19457,
	"./minimalism/0294S.png": 96673,
	"./minimalism/0295S.png": 80793,
	"./minimalism/0296S.png": 40829,
	"./minimalism/0297S.png": 82184,
	"./minimalism/0298S.png": 87809,
	"./minimalism/0299S.png": 31319,
	"./minimalism/0300S.png": 26721,
	"./minimalism/0301S.png": 11857,
	"./minimalism/0302S.png": 32882,
	"./minimalism/0408S.png": 74527,
	"./minimalism/0409S.png": 58046,
	"./minimalism/0410S.png": 25685,
	"./minimalism/0411S.png": 52238,
	"./minimalism/0412S.png": 97096,
	"./minimalism/0413S.png": 95207,
	"./minimalism/0414S.png": 74344,
	"./minimalism/0415S.png": 81800,
	"./minimalism/0416S.png": 46012,
	"./minimalism/0417S.png": 77881,
	"./minimalism/0418S.png": 79541,
	"./minimalism/0419S.png": 96916,
	"./minimalism/0420S.png": 84726,
	"./minimalism/0421S.png": 26626,
	"./minimalism/0527S.png": 9342,
	"./minimalism/0528S.png": 88179,
	"./minimalism/0529S.png": 90047,
	"./minimalism/0530S.png": 30419,
	"./minimalism/0531S.png": 57172,
	"./minimalism/0532S.png": 93426,
	"./minimalism/0533S.png": 10105,
	"./minimalism/0534S.png": 48548,
	"./minimalism/0535S.png": 66168,
	"./minimalism/0536S.png": 34725,
	"./minimalism/0537S.png": 78606,
	"./minimalism/0538S.png": 85950,
	"./minimalism/0539S.png": 60581,
	"./minimalism/0540S.png": 46968,
	"./minimalism/0646S.png": 77842,
	"./minimalism/0647S.png": 52889,
	"./minimalism/0648S.png": 7573,
	"./minimalism/0649S.png": 31858,
	"./minimalism/0650S.png": 1006,
	"./minimalism/0651S.png": 21614,
	"./minimalism/0652S.png": 60796,
	"./minimalism/0653S.png": 73526,
	"./minimalism/0654S.png": 74824,
	"./minimalism/0655S.png": 63436,
	"./minimalism/0656S.png": 6683,
	"./minimalism/0657S.png": 41271,
	"./minimalism/0658S.png": 57707,
	"./minimalism/0659S.png": 56614,
	"./minimalism/0765S.png": 29197,
	"./minimalism/0766S.png": 39524,
	"./minimalism/0767S.png": 703,
	"./minimalism/0768S.png": 56418,
	"./minimalism/0769S.png": 57139,
	"./minimalism/0770S.png": 15654,
	"./minimalism/0771S.png": 15955,
	"./minimalism/0772S.png": 50317,
	"./minimalism/0773S.png": 86897,
	"./minimalism/0774S.png": 2073,
	"./minimalism/0775S.png": 31047,
	"./minimalism/0776S.png": 63417,
	"./minimalism/0777S.png": 79676,
	"./minimalism/0778S.png": 63788,
	"./minimalism/0884S.png": 99755,
	"./minimalism/0885S.png": 56960,
	"./minimalism/0886S.png": 34710,
	"./minimalism/0887S.png": 6034,
	"./minimalism/0888S.png": 52231,
	"./minimalism/0889S.png": 35804,
	"./minimalism/0890S.png": 85330,
	"./minimalism/0891S.png": 52605,
	"./minimalism/0892S.png": 55705,
	"./minimalism/0893S.png": 87114,
	"./minimalism/0894S.png": 89094,
	"./minimalism/0895S.png": 17400,
	"./minimalism/0896S.png": 77300,
	"./minimalism/0897S.png": 17864,
	"./minimalism/1003S.png": 89914,
	"./minimalism/1004S.png": 16637,
	"./minimalism/1005S.png": 81906,
	"./minimalism/1006S.png": 19481,
	"./minimalism/1007S.png": 74494,
	"./minimalism/1008S.png": 40449,
	"./minimalism/1009S.png": 80491,
	"./minimalism/1010S.png": 50861,
	"./minimalism/1011S.png": 80741,
	"./minimalism/1012S.png": 24525,
	"./minimalism/1013S.png": 4167,
	"./minimalism/1014S.png": 91377,
	"./minimalism/1015S.png": 68626,
	"./minimalism/1016S.png": 99674,
	"./minimalism/1122S.png": 23626,
	"./minimalism/1123S.png": 15322,
	"./minimalism/1124S.png": 69424,
	"./minimalism/1125S.png": 7420,
	"./minimalism/1126S.png": 11518,
	"./minimalism/1127S.png": 55254,
	"./minimalism/1128S.png": 81881,
	"./minimalism/1129S.png": 56817,
	"./minimalism/1130S.png": 99318,
	"./minimalism/1131S.png": 40057,
	"./minimalism/1132S.png": 27105,
	"./minimalism/1133S.png": 93504,
	"./minimalism/1134S.png": 48952,
	"./minimalism/1135S.png": 64673,
	"./minimalism/1241S.png": 11122,
	"./minimalism/1242S.png": 9128,
	"./minimalism/1243S.png": 99858,
	"./minimalism/1244S.png": 17149,
	"./minimalism/1245S.png": 32266,
	"./minimalism/1246S.png": 41243,
	"./minimalism/1247S.png": 99403,
	"./minimalism/1248S.png": 1222,
	"./minimalism/1249S.png": 29139,
	"./minimalism/1250S.png": 60679,
	"./minimalism/1251S.png": 87186,
	"./minimalism/1252S.png": 13477,
	"./minimalism/1253S.png": 75396,
	"./minimalism/1254S.png": 69146,
	"./minimalism/1360S.png": 65180,
	"./minimalism/1361S.png": 11308,
	"./minimalism/1362S.png": 62380,
	"./minimalism/1363S.png": 95135,
	"./minimalism/1364S.png": 86284,
	"./minimalism/1365S.png": 9729,
	"./minimalism/1366S.png": 38788,
	"./minimalism/1367S.png": 43154,
	"./minimalism/1368S.png": 33655,
	"./minimalism/1369S.png": 59573,
	"./minimalism/1370S.png": 72763,
	"./minimalism/1371S.png": 85183,
	"./minimalism/1372S.png": 92303,
	"./minimalism/1373S.png": 18688,
	"./narcissism/0065S.png": 7077,
	"./narcissism/0066S.png": 33993,
	"./narcissism/0067S.png": 59154,
	"./narcissism/0068S.png": 87016,
	"./narcissism/0069S.png": 97708,
	"./narcissism/0070S.png": 2050,
	"./narcissism/0071S.png": 25128,
	"./narcissism/0072S.png": 34738,
	"./narcissism/0073S.png": 95146,
	"./narcissism/0074S.png": 77084,
	"./narcissism/0075S.png": 13827,
	"./narcissism/0076S.png": 66079,
	"./narcissism/0077S.png": 94657,
	"./narcissism/0184S.png": 80384,
	"./narcissism/0185S.png": 4018,
	"./narcissism/0186S.png": 87710,
	"./narcissism/0187S.png": 63282,
	"./narcissism/0188S.png": 91011,
	"./narcissism/0189S.png": 62814,
	"./narcissism/0190S.png": 34651,
	"./narcissism/0191S.png": 98801,
	"./narcissism/0192S.png": 28350,
	"./narcissism/0193S.png": 5413,
	"./narcissism/0194S.png": 49725,
	"./narcissism/0195S.png": 74158,
	"./narcissism/0196S.png": 26378,
	"./narcissism/0303S.png": 58068,
	"./narcissism/0304S.png": 77902,
	"./narcissism/0305S.png": 62286,
	"./narcissism/0306S.png": 72277,
	"./narcissism/0307S.png": 53638,
	"./narcissism/0308S.png": 70204,
	"./narcissism/0309S.png": 38554,
	"./narcissism/0310S.png": 81046,
	"./narcissism/0311S.png": 68539,
	"./narcissism/0312S.png": 72735,
	"./narcissism/0313S.png": 2078,
	"./narcissism/0314S.png": 45825,
	"./narcissism/0315S.png": 83296,
	"./narcissism/0422S.png": 96512,
	"./narcissism/0423S.png": 71791,
	"./narcissism/0424S.png": 68827,
	"./narcissism/0425S.png": 44237,
	"./narcissism/0426S.png": 31449,
	"./narcissism/0427S.png": 4198,
	"./narcissism/0428S.png": 11211,
	"./narcissism/0429S.png": 64892,
	"./narcissism/0430S.png": 81677,
	"./narcissism/0431S.png": 66367,
	"./narcissism/0432S.png": 13012,
	"./narcissism/0433S.png": 14005,
	"./narcissism/0434S.png": 2402,
	"./narcissism/0541S.png": 4325,
	"./narcissism/0542S.png": 72374,
	"./narcissism/0543S.png": 32475,
	"./narcissism/0544S.png": 53587,
	"./narcissism/0545S.png": 2611,
	"./narcissism/0546S.png": 59472,
	"./narcissism/0547S.png": 97950,
	"./narcissism/0548S.png": 5060,
	"./narcissism/0549S.png": 46751,
	"./narcissism/0550S.png": 97287,
	"./narcissism/0551S.png": 1306,
	"./narcissism/0552S.png": 88835,
	"./narcissism/0553S.png": 98762,
	"./narcissism/0660S.png": 9143,
	"./narcissism/0661S.png": 14754,
	"./narcissism/0662S.png": 11706,
	"./narcissism/0663S.png": 1491,
	"./narcissism/0664S.png": 57055,
	"./narcissism/0665S.png": 69916,
	"./narcissism/0666S.png": 55519,
	"./narcissism/0667S.png": 36196,
	"./narcissism/0668S.png": 9834,
	"./narcissism/0669S.png": 17316,
	"./narcissism/0670S.png": 63955,
	"./narcissism/0671S.png": 25176,
	"./narcissism/0672S.png": 88243,
	"./narcissism/0779S.png": 50880,
	"./narcissism/0780S.png": 14118,
	"./narcissism/0781S.png": 79922,
	"./narcissism/0782S.png": 35807,
	"./narcissism/0783S.png": 94962,
	"./narcissism/0784S.png": 49330,
	"./narcissism/0785S.png": 75935,
	"./narcissism/0786S.png": 68708,
	"./narcissism/0787S.png": 72162,
	"./narcissism/0788S.png": 31033,
	"./narcissism/0789S.png": 70301,
	"./narcissism/0790S.png": 61542,
	"./narcissism/0791S.png": 82638,
	"./narcissism/0898S.png": 86630,
	"./narcissism/0899S.png": 8718,
	"./narcissism/0900S.png": 22414,
	"./narcissism/0901S.png": 86260,
	"./narcissism/0902S.png": 47764,
	"./narcissism/0903S.png": 86747,
	"./narcissism/0904S.png": 29529,
	"./narcissism/0905S.png": 16552,
	"./narcissism/0906S.png": 92971,
	"./narcissism/0907S.png": 67303,
	"./narcissism/0908S.png": 69400,
	"./narcissism/0909S.png": 56831,
	"./narcissism/0910S.png": 11907,
	"./narcissism/1017S.png": 849,
	"./narcissism/1018S.png": 79869,
	"./narcissism/1019S.png": 23530,
	"./narcissism/1020S.png": 74324,
	"./narcissism/1021S.png": 94159,
	"./narcissism/1022S.png": 64587,
	"./narcissism/1023S.png": 49778,
	"./narcissism/1024S.png": 5586,
	"./narcissism/1025S.png": 25253,
	"./narcissism/1026S.png": 92148,
	"./narcissism/1027S.png": 9744,
	"./narcissism/1028S.png": 78475,
	"./narcissism/1029S.png": 33091,
	"./narcissism/1136S.png": 44702,
	"./narcissism/1137S.png": 31011,
	"./narcissism/1138S.png": 4554,
	"./narcissism/1139S.png": 49192,
	"./narcissism/1140S.png": 13695,
	"./narcissism/1141S.png": 41861,
	"./narcissism/1142S.png": 70135,
	"./narcissism/1143S.png": 4555,
	"./narcissism/1144S.png": 33729,
	"./narcissism/1145S.png": 89096,
	"./narcissism/1146S.png": 36596,
	"./narcissism/1147S.png": 27478,
	"./narcissism/1148S.png": 21172,
	"./narcissism/1255S.png": 15611,
	"./narcissism/1256S.png": 70029,
	"./narcissism/1257S.png": 56568,
	"./narcissism/1258S.png": 20603,
	"./narcissism/1259S.png": 87466,
	"./narcissism/1260S.png": 94065,
	"./narcissism/1261S.png": 30958,
	"./narcissism/1262S.png": 58605,
	"./narcissism/1263S.png": 11123,
	"./narcissism/1264S.png": 55151,
	"./narcissism/1265S.png": 79504,
	"./narcissism/1266S.png": 55521,
	"./narcissism/1267S.png": 6866,
	"./narcissism/1374S.png": 81198,
	"./narcissism/1375S.png": 3643,
	"./narcissism/1376S.png": 56995,
	"./narcissism/1377S.png": 2452,
	"./narcissism/1378S.png": 37823,
	"./narcissism/1379S.png": 75199,
	"./narcissism/1380S.png": 18875,
	"./narcissism/1381S.png": 13183,
	"./narcissism/1382S.png": 70405,
	"./narcissism/1383S.png": 35803,
	"./narcissism/1384S.png": 21266,
	"./narcissism/1385S.png": 19646,
	"./narcissism/1386S.png": 94237,
	"./nihilism/0078S.png": 16741,
	"./nihilism/0079S.png": 6146,
	"./nihilism/0080S.png": 17157,
	"./nihilism/0081S.png": 78166,
	"./nihilism/0082S.png": 10140,
	"./nihilism/0083S.png": 38463,
	"./nihilism/0084S.png": 18102,
	"./nihilism/0085S.png": 89961,
	"./nihilism/0086S.png": 39164,
	"./nihilism/0087S.png": 2184,
	"./nihilism/0088S.png": 8975,
	"./nihilism/0089S.png": 58318,
	"./nihilism/0197S.png": 65964,
	"./nihilism/0198S.png": 94205,
	"./nihilism/0199S.png": 66771,
	"./nihilism/0200S.png": 25771,
	"./nihilism/0201S.png": 48942,
	"./nihilism/0202S.png": 42474,
	"./nihilism/0203S.png": 21310,
	"./nihilism/0204S.png": 20419,
	"./nihilism/0205S.png": 4553,
	"./nihilism/0206S.png": 50093,
	"./nihilism/0207S.png": 95338,
	"./nihilism/0208S.png": 42316,
	"./nihilism/0316S.png": 60180,
	"./nihilism/0317S.png": 21650,
	"./nihilism/0318S.png": 24195,
	"./nihilism/0319S.png": 38223,
	"./nihilism/0320S.png": 30721,
	"./nihilism/0321S.png": 56388,
	"./nihilism/0322S.png": 35981,
	"./nihilism/0323S.png": 42048,
	"./nihilism/0324S.png": 20437,
	"./nihilism/0325S.png": 67267,
	"./nihilism/0326S.png": 45478,
	"./nihilism/0327S.png": 99524,
	"./nihilism/0435S.png": 35868,
	"./nihilism/0436S.png": 35972,
	"./nihilism/0437S.png": 77312,
	"./nihilism/0438S.png": 61105,
	"./nihilism/0439S.png": 91493,
	"./nihilism/0440S.png": 85456,
	"./nihilism/0441S.png": 92334,
	"./nihilism/0442S.png": 62669,
	"./nihilism/0443S.png": 1578,
	"./nihilism/0444S.png": 4227,
	"./nihilism/0445S.png": 78303,
	"./nihilism/0446S.png": 64676,
	"./nihilism/0554S.png": 44144,
	"./nihilism/0555S.png": 13951,
	"./nihilism/0556S.png": 70271,
	"./nihilism/0557S.png": 24651,
	"./nihilism/0558S.png": 47344,
	"./nihilism/0559S.png": 81650,
	"./nihilism/0560S.png": 67910,
	"./nihilism/0561S.png": 22566,
	"./nihilism/0562S.png": 66316,
	"./nihilism/0563S.png": 70460,
	"./nihilism/0564S.png": 67711,
	"./nihilism/0565S.png": 76044,
	"./nihilism/0673S.png": 28281,
	"./nihilism/0674S.png": 86756,
	"./nihilism/0675S.png": 19726,
	"./nihilism/0676S.png": 10296,
	"./nihilism/0677S.png": 46088,
	"./nihilism/0678S.png": 71428,
	"./nihilism/0679S.png": 43641,
	"./nihilism/0680S.png": 51739,
	"./nihilism/0681S.png": 62095,
	"./nihilism/0682S.png": 58184,
	"./nihilism/0683S.png": 49595,
	"./nihilism/0684S.png": 79164,
	"./nihilism/0792S.png": 16620,
	"./nihilism/0793S.png": 13780,
	"./nihilism/0794S.png": 70987,
	"./nihilism/0795S.png": 63970,
	"./nihilism/0796S.png": 4074,
	"./nihilism/0797S.png": 32216,
	"./nihilism/0798S.png": 21786,
	"./nihilism/0799S.png": 99174,
	"./nihilism/0800S.png": 49281,
	"./nihilism/0801S.png": 7137,
	"./nihilism/0802S.png": 83745,
	"./nihilism/0803S.png": 50322,
	"./nihilism/0911S.png": 53962,
	"./nihilism/0912S.png": 37019,
	"./nihilism/0913S.png": 8188,
	"./nihilism/0914S.png": 4106,
	"./nihilism/0915S.png": 15268,
	"./nihilism/0916S.png": 20114,
	"./nihilism/0917S.png": 76236,
	"./nihilism/0918S.png": 33882,
	"./nihilism/0919S.png": 94897,
	"./nihilism/0920S.png": 62861,
	"./nihilism/0921S.png": 18940,
	"./nihilism/0922S.png": 67116,
	"./nihilism/1030S.png": 63191,
	"./nihilism/1031S.png": 35607,
	"./nihilism/1032S.png": 64751,
	"./nihilism/1033S.png": 1162,
	"./nihilism/1034S.png": 96991,
	"./nihilism/1035S.png": 49895,
	"./nihilism/1036S.png": 24517,
	"./nihilism/1037S.png": 61779,
	"./nihilism/1038S.png": 87343,
	"./nihilism/1039S.png": 82681,
	"./nihilism/1040S.png": 14518,
	"./nihilism/1041S.png": 96970,
	"./nihilism/1149S.png": 67393,
	"./nihilism/1150S.png": 35348,
	"./nihilism/1151S.png": 3980,
	"./nihilism/1152S.png": 91325,
	"./nihilism/1153S.png": 91159,
	"./nihilism/1154S.png": 64611,
	"./nihilism/1155S.png": 34394,
	"./nihilism/1156S.png": 7718,
	"./nihilism/1157S.png": 94615,
	"./nihilism/1158S.png": 10364,
	"./nihilism/1159S.png": 13021,
	"./nihilism/1160S.png": 23364,
	"./nihilism/1268S.png": 70759,
	"./nihilism/1269S.png": 79188,
	"./nihilism/1270S.png": 86711,
	"./nihilism/1271S.png": 71149,
	"./nihilism/1272S.png": 9322,
	"./nihilism/1273S.png": 96789,
	"./nihilism/1274S.png": 68874,
	"./nihilism/1275S.png": 83416,
	"./nihilism/1276S.png": 77309,
	"./nihilism/1277S.png": 22999,
	"./nihilism/1278S.png": 55653,
	"./nihilism/1279S.png": 68275,
	"./nihilism/1387S.png": 62911,
	"./nihilism/1388S.png": 25753,
	"./nihilism/1389S.png": 12507,
	"./nihilism/1390S.png": 67098,
	"./nihilism/1391S.png": 21960,
	"./nihilism/1392S.png": 2695,
	"./nihilism/1393S.png": 93379,
	"./nihilism/1394S.png": 69178,
	"./nihilism/1395S.png": 92482,
	"./nihilism/1396S.png": 49352,
	"./nihilism/1397S.png": 94424,
	"./nihilism/1398S.png": 39811,
	"./optimism/0090S.png": 66687,
	"./optimism/0091S.png": 90958,
	"./optimism/0092S.png": 39458,
	"./optimism/0093S.png": 87714,
	"./optimism/0094S.png": 71237,
	"./optimism/0095S.png": 46578,
	"./optimism/0096S.png": 50548,
	"./optimism/0097S.png": 18183,
	"./optimism/0098S.png": 78056,
	"./optimism/0099S.png": 37281,
	"./optimism/0209S.png": 94051,
	"./optimism/0210S.png": 78860,
	"./optimism/0211S.png": 23224,
	"./optimism/0212S.png": 86415,
	"./optimism/0213S.png": 8038,
	"./optimism/0214S.png": 71200,
	"./optimism/0215S.png": 10857,
	"./optimism/0216S.png": 1618,
	"./optimism/0217S.png": 77540,
	"./optimism/0218S.png": 38339,
	"./optimism/0328S.png": 67990,
	"./optimism/0329S.png": 20298,
	"./optimism/0330S.png": 34600,
	"./optimism/0331S.png": 1082,
	"./optimism/0332S.png": 89130,
	"./optimism/0333S.png": 73077,
	"./optimism/0334S.png": 60205,
	"./optimism/0335S.png": 97171,
	"./optimism/0336S.png": 45056,
	"./optimism/0337S.png": 86230,
	"./optimism/0447S.png": 60889,
	"./optimism/0448S.png": 12649,
	"./optimism/0449S.png": 84550,
	"./optimism/0450S.png": 39448,
	"./optimism/0451S.png": 10742,
	"./optimism/0452S.png": 53957,
	"./optimism/0453S.png": 3701,
	"./optimism/0454S.png": 98343,
	"./optimism/0455S.png": 85585,
	"./optimism/0456S.png": 52960,
	"./optimism/0566S.png": 38674,
	"./optimism/0567S.png": 26810,
	"./optimism/0568S.png": 81093,
	"./optimism/0569S.png": 1312,
	"./optimism/0570S.png": 2130,
	"./optimism/0571S.png": 78385,
	"./optimism/0572S.png": 13731,
	"./optimism/0573S.png": 24540,
	"./optimism/0574S.png": 42479,
	"./optimism/0575S.png": 22744,
	"./optimism/0685S.png": 54494,
	"./optimism/0686S.png": 4882,
	"./optimism/0687S.png": 11078,
	"./optimism/0688S.png": 49364,
	"./optimism/0689S.png": 37410,
	"./optimism/0690S.png": 20146,
	"./optimism/0691S.png": 51430,
	"./optimism/0692S.png": 42351,
	"./optimism/0693S.png": 80085,
	"./optimism/0694S.png": 37561,
	"./optimism/0804S.png": 89085,
	"./optimism/0805S.png": 34629,
	"./optimism/0806S.png": 2071,
	"./optimism/0807S.png": 66998,
	"./optimism/0808S.png": 48912,
	"./optimism/0809S.png": 90489,
	"./optimism/0810S.png": 16131,
	"./optimism/0811S.png": 41556,
	"./optimism/0812S.png": 61246,
	"./optimism/0813S.png": 37181,
	"./optimism/0923S.png": 41496,
	"./optimism/0924S.png": 10152,
	"./optimism/0925S.png": 73505,
	"./optimism/0926S.png": 4625,
	"./optimism/0927S.png": 20201,
	"./optimism/0928S.png": 6479,
	"./optimism/0929S.png": 39883,
	"./optimism/0930S.png": 58858,
	"./optimism/0931S.png": 46023,
	"./optimism/0932S.png": 42559,
	"./optimism/1042S.png": 92986,
	"./optimism/1043S.png": 92570,
	"./optimism/1044S.png": 74323,
	"./optimism/1045S.png": 98828,
	"./optimism/1046S.png": 589,
	"./optimism/1047S.png": 99291,
	"./optimism/1048S.png": 95090,
	"./optimism/1049S.png": 7625,
	"./optimism/1050S.png": 92601,
	"./optimism/1051S.png": 12074,
	"./optimism/1161S.png": 47539,
	"./optimism/1162S.png": 60748,
	"./optimism/1163S.png": 82340,
	"./optimism/1164S.png": 44390,
	"./optimism/1165S.png": 74392,
	"./optimism/1166S.png": 84878,
	"./optimism/1167S.png": 28972,
	"./optimism/1168S.png": 17283,
	"./optimism/1169S.png": 34727,
	"./optimism/1170S.png": 22881,
	"./optimism/1280S.png": 9606,
	"./optimism/1281S.png": 50945,
	"./optimism/1282S.png": 78917,
	"./optimism/1283S.png": 64599,
	"./optimism/1284S.png": 56319,
	"./optimism/1285S.png": 87021,
	"./optimism/1286S.png": 98498,
	"./optimism/1287S.png": 54055,
	"./optimism/1288S.png": 60117,
	"./optimism/1289S.png": 20059,
	"./optimism/1399S.png": 30177,
	"./optimism/1400S.png": 45793,
	"./optimism/1401S.png": 813,
	"./optimism/1402S.png": 27842,
	"./optimism/1403S.png": 8320,
	"./optimism/1404S.png": 37439,
	"./optimism/1405S.png": 78649,
	"./optimism/1406S.png": 29429,
	"./optimism/1407S.png": 17573,
	"./optimism/1408S.png": 871,
	"./stoicism/0100S.png": 86240,
	"./stoicism/0101S.png": 79625,
	"./stoicism/0102S.png": 71606,
	"./stoicism/0103S.png": 23138,
	"./stoicism/0104S.png": 22769,
	"./stoicism/0105S.png": 92992,
	"./stoicism/0106S.png": 20916,
	"./stoicism/0107S.png": 34596,
	"./stoicism/0108S.png": 70336,
	"./stoicism/0109S.png": 74530,
	"./stoicism/0110S.png": 39676,
	"./stoicism/0111S.png": 92179,
	"./stoicism/0112S.png": 71822,
	"./stoicism/0113S.png": 86146,
	"./stoicism/0114S.png": 91367,
	"./stoicism/0115S.png": 8081,
	"./stoicism/0116S.png": 4334,
	"./stoicism/0117S.png": 26792,
	"./stoicism/0118S.png": 36535,
	"./stoicism/0219S.png": 71451,
	"./stoicism/0220S.png": 40877,
	"./stoicism/0221S.png": 61169,
	"./stoicism/0222S.png": 91392,
	"./stoicism/0223S.png": 71741,
	"./stoicism/0224S.png": 8118,
	"./stoicism/0225S.png": 48733,
	"./stoicism/0226S.png": 44328,
	"./stoicism/0227S.png": 7278,
	"./stoicism/0228S.png": 40619,
	"./stoicism/0229S.png": 11710,
	"./stoicism/0230S.png": 22629,
	"./stoicism/0231S.png": 73295,
	"./stoicism/0232S.png": 56933,
	"./stoicism/0233S.png": 11023,
	"./stoicism/0234S.png": 91056,
	"./stoicism/0235S.png": 14886,
	"./stoicism/0236S.png": 7069,
	"./stoicism/0237S.png": 33593,
	"./stoicism/0338S.png": 72242,
	"./stoicism/0339S.png": 61037,
	"./stoicism/0340S.png": 55946,
	"./stoicism/0341S.png": 22258,
	"./stoicism/0342S.png": 95418,
	"./stoicism/0343S.png": 66956,
	"./stoicism/0344S.png": 81844,
	"./stoicism/0345S.png": 58328,
	"./stoicism/0346S.png": 69867,
	"./stoicism/0347S.png": 47350,
	"./stoicism/0348S.png": 34755,
	"./stoicism/0349S.png": 2567,
	"./stoicism/0350S.png": 69848,
	"./stoicism/0351S.png": 3669,
	"./stoicism/0352S.png": 30118,
	"./stoicism/0353S.png": 23141,
	"./stoicism/0354S.png": 32749,
	"./stoicism/0355S.png": 16463,
	"./stoicism/0356S.png": 99893,
	"./stoicism/0457S.png": 83079,
	"./stoicism/0458S.png": 88003,
	"./stoicism/0459S.png": 94563,
	"./stoicism/0460S.png": 24411,
	"./stoicism/0461S.png": 17008,
	"./stoicism/0462S.png": 76571,
	"./stoicism/0463S.png": 13146,
	"./stoicism/0464S.png": 31822,
	"./stoicism/0465S.png": 50605,
	"./stoicism/0466S.png": 77451,
	"./stoicism/0467S.png": 78348,
	"./stoicism/0468S.png": 41141,
	"./stoicism/0469S.png": 18569,
	"./stoicism/0470S.png": 51713,
	"./stoicism/0471S.png": 90309,
	"./stoicism/0472S.png": 82861,
	"./stoicism/0473S.png": 93133,
	"./stoicism/0474S.png": 24745,
	"./stoicism/0475S.png": 2634,
	"./stoicism/0576S.png": 76845,
	"./stoicism/0577S.png": 41945,
	"./stoicism/0578S.png": 67546,
	"./stoicism/0579S.png": 81187,
	"./stoicism/0580S.png": 89750,
	"./stoicism/0581S.png": 95705,
	"./stoicism/0582S.png": 68473,
	"./stoicism/0583S.png": 9613,
	"./stoicism/0584S.png": 92559,
	"./stoicism/0585S.png": 4633,
	"./stoicism/0586S.png": 41181,
	"./stoicism/0587S.png": 16415,
	"./stoicism/0588S.png": 58291,
	"./stoicism/0589S.png": 49597,
	"./stoicism/0590S.png": 77708,
	"./stoicism/0591S.png": 27003,
	"./stoicism/0592S.png": 18530,
	"./stoicism/0593S.png": 44355,
	"./stoicism/0594S.png": 15609,
	"./stoicism/0695S.png": 61637,
	"./stoicism/0696S.png": 52881,
	"./stoicism/0697S.png": 17066,
	"./stoicism/0698S.png": 19354,
	"./stoicism/0699S.png": 52706,
	"./stoicism/0700S.png": 33985,
	"./stoicism/0701S.png": 8879,
	"./stoicism/0702S.png": 81625,
	"./stoicism/0703S.png": 17493,
	"./stoicism/0704S.png": 21232,
	"./stoicism/0705S.png": 40710,
	"./stoicism/0706S.png": 95850,
	"./stoicism/0707S.png": 26490,
	"./stoicism/0708S.png": 84013,
	"./stoicism/0709S.png": 73861,
	"./stoicism/0710S.png": 47106,
	"./stoicism/0711S.png": 13509,
	"./stoicism/0712S.png": 22832,
	"./stoicism/0713S.png": 51854,
	"./stoicism/0814S.png": 74029,
	"./stoicism/0815S.png": 46108,
	"./stoicism/0816S.png": 15841,
	"./stoicism/0817S.png": 55963,
	"./stoicism/0818S.png": 45622,
	"./stoicism/0819S.png": 27033,
	"./stoicism/0820S.png": 78146,
	"./stoicism/0821S.png": 70331,
	"./stoicism/0822S.png": 94313,
	"./stoicism/0823S.png": 36691,
	"./stoicism/0824S.png": 50786,
	"./stoicism/0825S.png": 24848,
	"./stoicism/0826S.png": 82718,
	"./stoicism/0827S.png": 33867,
	"./stoicism/0828S.png": 52090,
	"./stoicism/0829S.png": 41534,
	"./stoicism/0830S.png": 63237,
	"./stoicism/0831S.png": 91610,
	"./stoicism/0832S.png": 83993,
	"./stoicism/0933S.png": 28738,
	"./stoicism/0934S.png": 72037,
	"./stoicism/0935S.png": 63800,
	"./stoicism/0936S.png": 31663,
	"./stoicism/0937S.png": 51266,
	"./stoicism/0938S.png": 34226,
	"./stoicism/0939S.png": 50024,
	"./stoicism/0940S.png": 48489,
	"./stoicism/0941S.png": 28072,
	"./stoicism/0942S.png": 42444,
	"./stoicism/0943S.png": 43812,
	"./stoicism/0944S.png": 65684,
	"./stoicism/0945S.png": 10579,
	"./stoicism/0946S.png": 95269,
	"./stoicism/0947S.png": 87835,
	"./stoicism/0948S.png": 15945,
	"./stoicism/0949S.png": 93538,
	"./stoicism/0950S.png": 47890,
	"./stoicism/0951S.png": 24171,
	"./stoicism/1052S.png": 92833,
	"./stoicism/1053S.png": 42599,
	"./stoicism/1054S.png": 54585,
	"./stoicism/1055S.png": 31574,
	"./stoicism/1056S.png": 99618,
	"./stoicism/1057S.png": 39150,
	"./stoicism/1058S.png": 52380,
	"./stoicism/1059S.png": 51889,
	"./stoicism/1060S.png": 71493,
	"./stoicism/1061S.png": 84463,
	"./stoicism/1062S.png": 77906,
	"./stoicism/1063S.png": 49860,
	"./stoicism/1064S.png": 9795,
	"./stoicism/1065S.png": 5625,
	"./stoicism/1066S.png": 17572,
	"./stoicism/1067S.png": 25548,
	"./stoicism/1068S.png": 26368,
	"./stoicism/1069S.png": 34376,
	"./stoicism/1070S.png": 62035,
	"./stoicism/1171S.png": 40786,
	"./stoicism/1172S.png": 12285,
	"./stoicism/1173S.png": 77992,
	"./stoicism/1174S.png": 80627,
	"./stoicism/1175S.png": 90643,
	"./stoicism/1176S.png": 20943,
	"./stoicism/1177S.png": 80858,
	"./stoicism/1178S.png": 98910,
	"./stoicism/1179S.png": 8971,
	"./stoicism/1180S.png": 89480,
	"./stoicism/1181S.png": 38971,
	"./stoicism/1182S.png": 46034,
	"./stoicism/1183S.png": 79657,
	"./stoicism/1184S.png": 28457,
	"./stoicism/1185S.png": 39050,
	"./stoicism/1186S.png": 65020,
	"./stoicism/1187S.png": 99335,
	"./stoicism/1188S.png": 39000,
	"./stoicism/1189S.png": 55498,
	"./stoicism/1290S.png": 50347,
	"./stoicism/1291S.png": 20300,
	"./stoicism/1292S.png": 78692,
	"./stoicism/1293S.png": 50859,
	"./stoicism/1294S.png": 1197,
	"./stoicism/1295S.png": 71714,
	"./stoicism/1296S.png": 66485,
	"./stoicism/1297S.png": 87102,
	"./stoicism/1298S.png": 36590,
	"./stoicism/1299S.png": 27098,
	"./stoicism/1300S.png": 88793,
	"./stoicism/1301S.png": 41819,
	"./stoicism/1302S.png": 75430,
	"./stoicism/1303S.png": 36898,
	"./stoicism/1304S.png": 32481,
	"./stoicism/1305S.png": 71313,
	"./stoicism/1306S.png": 81576,
	"./stoicism/1307S.png": 84963,
	"./stoicism/1308S.png": 56492,
	"./stoicism/1409S.png": 25785,
	"./stoicism/1410S.png": 28421,
	"./stoicism/1411S.png": 24058,
	"./stoicism/1412S.png": 81227,
	"./stoicism/1413S.png": 53746,
	"./stoicism/1414S.png": 254,
	"./stoicism/1415S.png": 81641,
	"./stoicism/1416S.png": 12547,
	"./stoicism/1417S.png": 93862,
	"./stoicism/1418S.png": 35688,
	"./stoicism/1419S.png": 39787,
	"./stoicism/1420S.png": 89549,
	"./stoicism/1421S.png": 50933,
	"./stoicism/1422S.png": 58679,
	"./stoicism/1423S.png": 50776,
	"./stoicism/1424S.png": 9694,
	"./stoicism/1425S.png": 61147,
	"./stoicism/1426S.png": 89015,
	"./stoicism/1427S.png": 42984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1693;